<!-- Layout correspondiente a la parte privada. Todas las rutas que lo usen asumen mínimo que el usuario está autenticado -->
<template>
  <Menu @toggle-notificationes="toggleNotificationes"></Menu>
  <main class="h-100">
    <!-- <div class="row">
      <h1>Esto es la zona privada. Soy "{{ auth.userInfo?.username }}"</h1>
      <DxButton @click="logout">{{ $t("shared.ui.buttons.logout") }}</DxButton>
    </div> -->
    <slot></slot>
  </main>
  <NotificacionesPanel :isVisible="notificacionesVisible" @close-notificaciones="toggleNotificationes"></NotificacionesPanel>
</template>
<script setup lang="ts">
import { provide, ref } from 'vue';
import Menu from "../menu/Menu.vue";
import NotificacionesPanel from "@components/notificaciones/NotificacionesPanel.vue";
import { useAuthentication } from "@services/auth";
import { useVersionCheck } from "@composables/useVersionCheck";

const auth = useAuthentication();
const notificacionesVisible = ref(false);
const numNotificacionesSinLeer = provide('numNotificacionesSinLeer', ref(0));

useVersionCheck();

function logout() {
  auth.logout(import.meta.env.VITE_BASE_URL);
}

function toggleNotificationes() {
  notificacionesVisible.value = !notificacionesVisible.value;
}
</script>
<style scoped>
main {
  padding: 30px 25px 30px 100px;
}

.contenedor-principal {
  min-height: calc(100vh - 125px);
}

@media (max-width: 992px) {
  main {
    padding: 100px 25px 50px;
  }
}
</style>
